import React from 'react';
import { Button, Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import { getSuggestionRegionTitle } from "../../utils";
import { EmptySearchResults } from "../EmptySearchResults";
import { EFetchStatus } from "../../../../store/slices/region";
import { Metric } from "../../../../metric";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var SearchResults = function SearchResults(_ref) {
  var suggestionsRegions = _ref.suggestionsRegions,
    status = _ref.status,
    _onClick = _ref.onClick;
  if (!suggestionsRegions.length && status === EFetchStatus.loaded) return /*#__PURE__*/React.createElement(EmptySearchResults, {
    "data-t-id": "components-SearchResults"
  });
  return /*#__PURE__*/React.createElement("ul", {
    className: cn('suggestions')
  }, suggestionsRegions.map(function (region) {
    return /*#__PURE__*/React.createElement("li", {
      className: cn('suggestions__item'),
      key: region.id
    }, /*#__PURE__*/React.createElement(Metric, {
      asChild: true,
      data: getSuggestionRegionTitle({
        city: region.title,
        customCity: region.customCity,
        area: region.area
      }),
      events: {
        headerMetric: ['handleChosenRegionClick']
      },
      mode: "click"
    }, /*#__PURE__*/React.createElement(Button, {
      mode: "inline",
      onClick: function onClick() {
        return _onClick(region);
      },
      view: "secondary",
      "data-t-id": "components-SearchResults"
    }, /*#__PURE__*/React.createElement(Text, {
      className: cn('suggestions__title'),
      color: "primary-invert",
      lineHeight: 20,
      size: 16,
      "data-t-id": "components-SearchResults"
    }, getSuggestionRegionTitle({
      city: region.title,
      customCity: region.customCity,
      area: region.area
    })))));
  }));
};